export type TeamLabel = 'Team' | 'Agent';

const TEAM_LABEL_KEY = 'teamLabelSubstitution';

export function getTeamLabel(): TeamLabel {
  try {
    const value = localStorage.getItem(TEAM_LABEL_KEY);
    return value === 'Agent' ? 'Agent' : 'Team';
  } catch {
    return 'Team';
  }
}

export function setTeamLabel(label: TeamLabel): void {
  try {
    localStorage.setItem(TEAM_LABEL_KEY, label);
  } catch {
    console.error('Failed to set team label in localStorage');
  }
}
